import CustomModalV2 from "../../../shared/custom-modal-v2/custom-modal-v2";
import TmdbImage from "../../../shared/tmdb-image/tmdb-image";
import UseUserPreferences from "../../../user-app-config/hooks/use-user-preferences";
import ItemBackdropDetails from "../../shared/item-backdrop-details/item-backdrop-details";
import TvModal from "../../squadflixTvTab/components/TvModal";

const SpoilersPreferenceModal = ({ serie }) => {

    const { userPreferences, loading: loadingPreferences, loadingUpdate: loadingUpdatePreferences, updatePreference } = UseUserPreferences();
    const isOpen = userPreferences.hideSpoilers == null && !loadingPreferences;

    if (userPreferences.tvMode) {
        return (
            <TvModal
                open={isOpen}
                onClose={() => updatePreference("hideSpoilers", true)}
                title="Configuración de Spoilers"
                subtitle="¿Quieres ocultar el nombre e imagen de los episodios que aún NO has visto? Podrás cambiarlo siempre en Ajustes.">
                <div className="tv-modal-list">
                    <button
                        type="button"
                        data-tv-focusable="true"
                        data-tv-autofocus="true"
                        className="tv-modal-option-btn"
                        onClick={() => updatePreference("hideSpoilers", true)}>
                        <span>
                            <i className="fa-solid fa-eye-slash pe-3 text-danger"></i>
                            <strong>Continuar sin Spoilers (Recomendado)</strong>
                            <small className="d-block text-muted mt-1">
                                Oculta título, sinopsis y miniatura de los episodios no vistos
                            </small>
                        </span>
                        <i className="fa-solid fa-chevron-right"></i>
                    </button>

                    <button
                        type="button"
                        data-tv-focusable="true"
                        className="tv-modal-option-btn"
                        onClick={() => updatePreference("hideSpoilers", false)}>
                        <span>
                            <i className="fa-solid fa-eye pe-3"></i>
                            <strong>Continuar con Spoilers</strong>
                            <small className="d-block text-muted mt-1">
                                Muestra todos los títulos, sinopsis e imágenes de los episodios
                            </small>
                        </span>
                        <i className="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </TvModal>
        );
    }

    return (

        <CustomModalV2
            open={isOpen} title="Configuración de Spoilers"
            closeOnBackdropClick={false} closeOnEscape={false}>


            <p>¿Quieres ocultar los spoilers? Se ocultará el <strong>nombre</strong> e <strong>imágen</strong> de los episodios que NO has visto.</p>

            <p>Podrás cambiar esta opción en cualquier momento desde la configuración de tu perfil.</p>

            <div className="d-flex flex-row align-items-center">
                <ItemBackdropDetails
                    hideOptionsIcon={true}
                    style={{
                        width: "47%",
                        marginRight: "6%"
                    }}
                    className="season-details__episodes--item"
                    onClickPoster={() => {
                        updatePreference("hideSpoilers", false);
                    }} onClickDetails={() => {
                        updatePreference("hideSpoilers", false);
                    }} tmdbSrc={serie.backdrop_path} size="w500"
                    isSpoiler={false}
                    detailsTitle={<>
                        <div className="season-details__episodes--item-title">
                            <span className="season-details__episodes--item-title-number">
                                Continuar con Spoilers <i className="fa-solid fa-chevron-right"></i>
                            </span>
                        </div>
                    </>}
                />
                <ItemBackdropDetails
                    hideOptionsIcon={true}
                    style={{
                        width: "47%"
                    }}
                    className="season-details__episodes--item"
                    onClickPoster={() => {
                        updatePreference("hideSpoilers", true);
                    }} onClickDetails={() => {
                        updatePreference("hideSpoilers", true);
                    }} tmdbSrc={serie.backdrop_path} size="w500"
                    isSpoiler={true}
                    detailsTitle={<>
                        <div className="season-details__episodes--item-title">
                            <span className="season-details__episodes--item-title-number">
                                Continuar sin Spoilers <i className="fa-solid fa-chevron-right"></i>
                            </span>
                        </div>
                    </>}
                />
            </div>
        </CustomModalV2>
    );
}

export default SpoilersPreferenceModal;